import React from 'react';
import './herofloat.css'

const Stat = (props) => {
    return ( <>
    <div className={props.style1}>
        <h2>
            {props.num}
        </h2>
            {props.title}
    </div>
    </> );
}
 
export default Stat;